'use strict';

function _newArrowCheck(innerThis, boundThis) { if (innerThis !== boundThis) { throw new TypeError("Cannot instantiate an arrow function"); } }

require('isomorphic-fetch');

var util = require('./util');

var Promise = require('es6-promise').Promise;

var BASE_URL = 'https://api.addsearch.com/v2/indices/';

var getHeaders = function getHeaders(sitekey, privatekey) {
  return {
    'Authorization': 'Basic ' + util.base64(sitekey + ':' + privatekey),
    'Content-Type': 'application/json'
  };
};
/**
 * Fetch document
 */


var getDocument = function getDocument(sitekey, privatekey, id) {
  var _this = this;

  var promise = new Promise(function (resolve, reject) {
    var _this2 = this;

    _newArrowCheck(this, _this);

    fetch(BASE_URL + sitekey + '/documents/' + id, {
      method: 'GET',
      headers: getHeaders(sitekey, privatekey)
    }).then(function (response) {
      _newArrowCheck(this, _this2);

      if (response.status == 200) {
        resolve(response.json());
      } else {
        reject({
          status: response.status,
          text: response.statusText
        });
      }
    }.bind(this)).catch(function (ex) {
      _newArrowCheck(this, _this2);

      reject({
        status: 400,
        text: ex
      });
    }.bind(this));
  }.bind(this));
  return promise;
};
/**
 * Add document
 */


var saveDocument = function saveDocument(sitekey, privatekey, document) {
  var _this3 = this;

  // If the doc has id or url field, PUT instead of POST
  var isPut = document.id || document.url;
  var promise = new Promise(function (resolve, reject) {
    var _this4 = this;

    _newArrowCheck(this, _this3);

    fetch(BASE_URL + sitekey + '/documents/', {
      method: isPut ? 'PUT' : 'POST',
      headers: getHeaders(sitekey, privatekey),
      body: JSON.stringify(document)
    }).then(function (response) {
      _newArrowCheck(this, _this4);

      if (response.status == 202) {
        resolve({
          status: response.status,
          text: response.statusText
        });
      } else {
        reject({
          status: response.status,
          text: response.statusText
        });
      }
    }.bind(this)).catch(function (ex) {
      _newArrowCheck(this, _this4);

      reject({
        status: 400,
        text: ex
      });
    }.bind(this));
  }.bind(this));
  return promise;
};
/**
 * Batch add documents
 */


var saveDocumentsBatch = function saveDocumentsBatch(sitekey, privatekey, documents) {
  var _this5 = this;

  var promise = new Promise(function (resolve, reject) {
    var _this6 = this;

    _newArrowCheck(this, _this5);

    fetch(BASE_URL + sitekey + '/documents:batch', {
      method: 'PUT',
      headers: getHeaders(sitekey, privatekey),
      body: JSON.stringify(documents)
    }).then(function (response) {
      _newArrowCheck(this, _this6);

      if (response.status == 202) {
        resolve({
          status: response.status,
          text: response.statusText
        });
      } else {
        reject({
          status: response.status,
          text: response.statusText
        });
      }
    }.bind(this)).catch(function (ex) {
      _newArrowCheck(this, _this6);

      reject({
        status: 400,
        text: ex
      });
    }.bind(this));
  }.bind(this));
  return promise;
};
/**
 * Delete documents
 */


var deleteDocument = function deleteDocument(sitekey, privatekey, id) {
  var _this7 = this;

  var promise = new Promise(function (resolve, reject) {
    var _this8 = this;

    _newArrowCheck(this, _this7);

    fetch(BASE_URL + sitekey + '/documents/' + id, {
      method: 'DELETE',
      headers: getHeaders(sitekey, privatekey)
    }).then(function (response) {
      _newArrowCheck(this, _this8);

      if (response.status == 202) {
        resolve({
          status: response.status,
          text: response.statusText
        });
      } else {
        reject({
          status: response.status,
          text: response.statusText
        });
      }
    }.bind(this)).catch(function (ex) {
      _newArrowCheck(this, _this8);

      reject({
        status: 400,
        text: ex
      });
    }.bind(this));
  }.bind(this));
  return promise;
};
/**
 * Batch delete documents
 */


var deleteDocumentsBatch = function deleteDocumentsBatch(sitekey, privatekey, batch) {
  var _this9 = this;

  var promise = new Promise(function (resolve, reject) {
    var _this10 = this;

    _newArrowCheck(this, _this9);

    fetch(BASE_URL + sitekey + '/documents:batch', {
      method: 'DELETE',
      headers: getHeaders(sitekey, privatekey),
      body: JSON.stringify(batch)
    }).then(function (response) {
      _newArrowCheck(this, _this10);

      if (response.status == 202) {
        resolve({
          status: response.status,
          text: response.statusText
        });
      } else {
        reject({
          status: response.status,
          text: response.statusText
        });
      }
    }.bind(this)).catch(function (ex) {
      _newArrowCheck(this, _this10);

      reject({
        status: 400,
        text: ex
      });
    }.bind(this));
  }.bind(this));
  return promise;
};

module.exports = {
  getDocument: getDocument,
  saveDocument: saveDocument,
  saveDocumentsBatch: saveDocumentsBatch,
  deleteDocument: deleteDocument,
  deleteDocumentsBatch: deleteDocumentsBatch
};